import { getUserRoles, isAuthenticated, isVerified } from '@/utils/auth';
import ActivationPage from '@/views/auth/ActivationPage.vue';
import ForgotPasswordPage from '@/views/auth/ForgotPasswordPage.vue';
import ResetPasswordOtpPage from '@/views/auth/ResetPasswordOtpPage.vue';
import SetNewPasswordPage from '@/views/auth/SetNewPasswordPage.vue';
import LoginPage from '@/views/LoginPage.vue';
import SignupPage from '@/views/SignupPage.vue';
import { createRouter, createWebHistory } from 'vue-router';
const HomePage = () => import('@/views/HomePage.vue');
const NotFound = () => import('@/views/NotFound.vue');
const routes = [
    {
        path: '/',
        name: 'home',
        component: HomePage,
        meta: { requiresAuth: true, showHeader: true, roles: ['user'] }
    },
    {
        path: '/login',
        name: 'login',
        component: LoginPage
    },
    {
        path: '/auth/activate',
        name: 'activate',
        component: ActivationPage
    },
    {
        path: '/auth/resetpwotp',
        name: 'resetpwotp',
        component: ResetPasswordOtpPage
    },
    {
        path: '/auth/forgotpw',
        name: 'resetpw',
        component: ForgotPasswordPage
    },
        {
        path: '/auth/setnewpw',
        name: 'setnewpw',
        component: SetNewPasswordPage
    },
    {
        path: '/signup',
        name: 'signup',
        component: SignupPage
    },
    { path: '/:catchAll(.*)', component: NotFound, meta: { showHeader: false } }
]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { el: to.hash };
        }
        return savedPosition || { top: 0 };
    }
});
router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'Emergency System'; // Fallback if no title
    const isAuthed = isAuthenticated(); // Implement your authentication check
    // Redirect to login if route requires auth and user is not authenticated
    if (to.meta.requiresAuth && !isAuthed) {
        return next({ name: 'login', query: { redirect: to.fullPath } })
    }

    // Redirect away from auth pages if already logged in
    if (to.meta.requiresGuest && isAuthed) {
        return next({ name: 'home' })
    }

    // Handle role-based access control
    if (to.meta.roles && to.meta.roles.length > 0) {
        const userRoles = getUserRoles(); // Example function to get user roles
        const allowedRoles = to.meta.roles;

        if (to.path !== "/auth/activate") {
            //check if verified
            if (!isVerified())
                return next('/auth/activate')
        }

        // Check if any of the user's roles match the allowed roles
        const hasAccess = userRoles.some(role => allowedRoles.includes(role));

        if (!hasAccess) {
            // Redirect to unauthorized page or handle unauthorized access
            return next('/forbidden'); // Example redirect to unauthorized page
        }

    }

    next()
})



export default router;
